import {useRef} from "react";
import {fileToBase64, compressFile} from "@/app/components/photo_upload/widget";
import {UserRequests} from "@/app/api/user";

const MAX_SIZE = 1024 * 1024;

export const usePhotoUpload = () => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const pickPhoto = (): Promise<string | undefined> => {
    return new Promise((resolve) => {
      if (!inputRef.current) {
        inputRef.current = document.createElement('input');
        inputRef.current.type = 'file';
        inputRef.current.accept = ".png,.jpg,.jpeg,.webp,.heic";
        inputRef.current.style.display = 'none';
        document.body.appendChild(inputRef.current);
      }

      inputRef.current.onchange = async (e: any) => {
        const file = e.target.files?.[0];
        if (!file) return resolve(undefined);
        let b64: string;
        if (file.size > MAX_SIZE) b64 = await compressFile(file);
        else b64 = await fileToBase64(file);

        resolve(b64);
        inputRef.current!.value = "";
      };

      inputRef.current.click();
    });
  };

  const uploadBase64 = async (dataUrl: string): Promise<string | undefined> => {
    const [header, base64] = dataUrl.split(',');
    const mime = header.match(/:(.*?);/)![1];
    const binary = atob(base64);
    const len = binary.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binary.charCodeAt(i);
    }
    const file = new File([arr], "upload.png", {type: mime});
    const formData = new FormData();
    formData.append('file', file);
    try {
      return await UserRequests.uploadImage(formData);
    } catch (err) {
      console.error(err);
      return undefined;
    }
  };

  return {
    pickPhoto,
    uploadBase64,
  };
};

export default usePhotoUpload;